export default {"src":"/_next/static/media/already-hired-builder.319f5c19.svg","height":26,"width":29,"blurWidth":0,"blurHeight":0};